import React from 'react';
import { TableViewComponent } from '../../../../ui-components/data-viz-ui/table/TableViewComponent';
import { OverTimeUnsegmentedTableViewUiComponentProps } from './types';

export const OverTimeUnsegmentedTableViewUiComponent = (
  props: OverTimeUnsegmentedTableViewUiComponentProps
) => {
  return <TableViewComponent {...props} />;
};
